
import { useRefreshTrigger } from '~/mixins/gsap'
import { useMatchMedia } from '~/mixins/responsive'

export default {
  mixins: [useRefreshTrigger, useMatchMedia],
  props: {
    blok: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedAvatar: {},
      masterTl: null,
    }
  },
  watch: {
    selectedAvatar: {
      handler(next, prev) {
        this.resetNodeColor()

        if (prev._uid) {
          // animate back to original position
          this.masterTl.to(`#img-${prev._uid}`, {
            scale: 1,
            duration: 0.1,
            clearProps: 'scale',
          })
          this.masterTl.to(
            `#avatar-container-${prev._uid}`,
            {
              yPercent: 0,
              xPercent: 0,
              zIndex: 20,
              duration: 0.2,
            },
            '+=.2'
          )
        }

        if (next._uid) {
          // new avatar selected
          this.animateAvatar()
          this.setActiveNodeColor(next)
        }
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initAnimation()
      this.resetNodeColor()
    })
  },
  methods: {
    initAnimation() {
      // map animation
      const tl = this.$gsap.timeline({
        scrollTrigger: {
          trigger: this.$refs['map-container'],
          start: 'top center',
          // markers: true,
        },
      })

      tl.from('.avatar', {
        alpha: 0,
        scale: 0.1,
        y: 60,
        ease: 'power1.inOut',
        stagger: 0.1,
      })

      this.masterTl = tl
    },
    resetNodeColor() {
      // reset to inital color for all nodes
      document.querySelectorAll('.node')?.forEach((x) => {
        x.style.color = '#5399D0'
        x.style.zIndex = '30'
      })
    },
    setActiveNodeColor(data) {
      // change node color to active state
      if (!data.location_city) return

      const getNodeByCity = document.querySelector(
        `[data-city*='${data.location_city}']`
      )
      if (getNodeByCity) {
        getNodeByCity.style.color = '#ED896F'
        getNodeByCity.style.zIndex = '50'
      }
    },
    setSeletedAvatar(data) {
      this.selectedAvatar = data
    },
    removeSelectedAvatar() {
      this.selectedAvatar = {}
    },
    animateAvatar() {
      const tl = this.$gsap.timeline()
      tl.to(`#img-${this.selectedAvatar._uid}`, 0.25, {
        scale: 2.5,
        duration: 0.2,
      })
      tl.to(
        `#avatar-container-${this.selectedAvatar._uid}`,
        {
          yPercent: this.selectedAvatar.pop_up_y || 0,
          xPercent: this.selectedAvatar.pop_up_x || 0,
          zIndex: 50,
          duration: 0.2,
          ease: 'power1.in',
        },
        '-=.3.5'
      )

      tl.from(
        `#content-${this.selectedAvatar._uid}`,
        0.25,
        {
          scaleX: 0,
          alpha: 0,
          transformOrigin: !this.selectedAvatar.text_direction_left
            ? 'left center'
            : 'right center',
          ease: 'Power4.easeOut',
        },
        '+=.1'
      )
    },
  },
}
